// extracted by mini-css-extract-plugin
export var measureBox = "_bz-0";